import { z } from "zod";
import { dmaUserSchema } from "../dma-user";
import { dmaIngredientDtoSchema } from "./dma-ingredient.schema";
export const dmaMixtureDtoSchema = z.object({
    id: z.number(),
    name: z.string(),
    composition: z.array(dmaIngredientDtoSchema),
    tags: z.array(z.string()),
    updatedAt: z.string().datetime(),
    updatedBy: z.nullable(dmaUserSchema),
});
